import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import auth from '@/store/auth'
import article from '@/store/vo/article'
import option from '@/store/vo/option'
import dashboard from '@/store/vo/dashboard'
import network from '@/store/vo/network'
import registration from '@/store/vo/registration'
import bonus from '@/store/vo/bonus'
import stockist from '@/store/vo/stockist'
import repeatOrder from '@/store/vo/repeatOrder'
import serial from '@/store/vo/serial'
import transferSerial from '@/store/vo/transferSerial'
import historySerial from '@/store/vo/historySerial'
import reward from '@/store/vo/reward'
import profile from '@/store/vo/profile'
import ewallet from '@/store/vo/ewallet'
import product from '@/store/vo/product'
import transactionProduct from '@/store/vo/transactionProduct'
import transactionSerial from '@/store/vo/transactionSerial'
import message from '@/store/vo/message'
import testimony from '@/store/vo/testimony'

import {
	PAGE_TITLE
} from './mutation-types';


export default new Vuex.Store({
	state: {
		pageTitle: "MLM Core VO",
		errorAlert : {
			show: false,
			color: 'red',
			alert: []
		},
		alert: {
			show: false
		},
		loading: false,
		snackbar: {
			show: false,
			color: 'green accent-4',
			text: ''
		},
	},
	mutations: {
		[PAGE_TITLE](state, title) {
			state.pageTitle = title;
		},
		makeAlert(state, data) {
			if (data.code != 406) {
				state.alert = data
			}
		},
		progress(state, data) {
			state.loading = data
		},
		setErrorAlert(state, data) {
			state.errorAlert = data
			state.snackbar.show = false
		},
		hideAlert(state) {
			state.errorAlert.show = false
		},
		setSnackbar(state, data) {
			state.snackbar = data
			state.errorAlert.show = false
		},
		hideSnackbar(state) {
			state.snackbar.show = false
		},
	},
	actions: {
		setPageTitle({ commit }, title) {
			commit(PAGE_TITLE, title);
		},
	},
	modules: {
		auth,
		article,
		option,
		dashboard,
		network,
		registration,
		bonus,
		stockist,
		repeatOrder,
		serial,
		transferSerial,
		historySerial,
		reward,
		profile,
		ewallet,
		product,
		transactionProduct,
		transactionSerial,
		message,
		testimony,
	}
});
